'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoUniversity = function IoUniversity(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 5l17.5 8.7-7.2 4.7-10.3 6.6-12.5-8v15.5l-2.5-1.2v-15.9l-2.5-1.6z m10.5 15l0.8 6.4c-1.3 0.9-8.8 6.1-11.3 8.6-2.5-2.5-10-7.7-11.2-8.6l0.7-6.4 10.5 6.9z' })
        )
    );
};

exports.default = IoUniversity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/university.js
// module id = 2517
// module chunks = 0